export const SET_FUNDER_PROGRESS_CACHE_ENTRY = "SET_FUNDER_PROGRESS_CACHE_ENTRY";
export const CLEAR_FUNDER_PROGRESS_CACHE = "CLEAR_FUNDER_PROGRESS_CACHE";

const initialState = {
  entries: {},
};

export default function funderProgressCacheReducer(state = initialState, action) {
  switch (action.type) {
    case SET_FUNDER_PROGRESS_CACHE_ENTRY: {
      const key = String(action.payload?.key || "").trim();
      if (!key) return state;
      return {
        ...state,
        entries: {
          ...state.entries,
          [key]: action.payload.value,
        },
      };
    }
    case CLEAR_FUNDER_PROGRESS_CACHE:
      return initialState;
    default:
      return state;
  }
}
